export default "__VITE_ASSET__126ce69f__"